'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;
exports.clear = clear;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'breadcrumbs/SET';
var CLEAR = 'breadcrumbs/CLEAR';

var initialState = {
  ids: '',
  items: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, initialState, action.breadcrumbs);
    case CLEAR:
      return (0, _extends3.default)({}, initialState);
    default:
      return state;
  }
}

function set(breadcrumbs) {
  return {
    type: SET,
    breadcrumbs: breadcrumbs
  };
}

function clear() {
  return {
    type: CLEAR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/breadcrumbs.js
// module id = 145
// module chunks = 0